import { Subject } from "rxjs";
import { RandomHelper } from "../../Lib/Helper/RandomHelper";

export class AxScrollspy {
    private Selector: string;
    private Offsets: Map<string, number>;

    private Offset: number;

    private Listener: any;
    private Guid: string;
    private Skip: number;

    private LastTarget: ScrollSubject;

    private ScrollSubject: Subject<ScrollSubject>;

    constructor(selector: string, offset?: number, skip?: number) {
        let randomHelper = new RandomHelper();
        this.Guid = randomHelper.GetGuid();
        this.Offset = offset || 0;
        this.ScrollSubject = new Subject<ScrollSubject>();
        this.Selector = selector;
        this.Skip = skip || 0;

        this.update();
        this.Listener = AxScrollSpyListener.Listener.bind(this);

        window.addEventListener("scroll", this.Listener);
    }

    update() {
        let sections = $(this.Selector);
        this.Offsets = new Map<string, number>();

        sections.each((i, e) => {
            this.Offsets.set(e.id, e.offsetTop);
        });
    }

    destroy() {
        window.removeEventListener("scroll", this.Listener);
    }

    getSubject() {
        return this.ScrollSubject;
    }

    getCurrentTarget() {
        return this.LastTarget;
    }

    next() {
        let currentOffsetTarget: number = this.LastTarget?.Offset ?? 0;
        let nextTargetOffset: number = 0;
        let count = 0;

        this.Offsets.forEach((i, key, map) => {
            if (count >= this.Skip) {
                let tmpOffset = map.get(key);
                if (tmpOffset > currentOffsetTarget && (nextTargetOffset == 0 || tmpOffset < nextTargetOffset)) {
                    nextTargetOffset = tmpOffset;
                }
            }
            count++;
        });

        window.scrollTo({
            top: nextTargetOffset - this.Offset,
            left: 0,
            behavior: 'smooth'
        });
    }

    previous() {
        let currentOffsetTarget: number = (document.documentElement.scrollTop || document.body.scrollTop) + this.Offset;
        let nextTargetOffset: number = 0;

        this.Offsets.forEach((i, key, map) => {
            let tmpOffset = map.get(key);
            if (tmpOffset < currentOffsetTarget && (nextTargetOffset == 0 || tmpOffset > nextTargetOffset)) {
                nextTargetOffset = tmpOffset;
            }
        });

        window.scrollTo({
            top: nextTargetOffset - this.Offset,
            left: 0,
            behavior: 'smooth'
        });
    }
}

const AxScrollSpyListener = {
    Listener() {
        let scrollPosition = (document.documentElement.scrollTop || document.body.scrollTop) + this.Offset;
        let lastIndex = '';

        this.Offsets.forEach((i, key, map) => {
            //console.log(`${key} -> ${map.get(key)} on ${scrollPosition} == ${map.get(key) <= scrollPosition}`);
            if (map.get(key) <= scrollPosition) {
                lastIndex = key;
            }
        });

        if (lastIndex != '' && (typeof (this.LastTarget) == 'undefined' || this.LastTarget.Id != lastIndex)) {
            this.LastTarget = new ScrollSubject(this.Guid, this.Selector, lastIndex, this.Offsets.get(lastIndex), $(`#${lastIndex}`)[0]);
            this.ScrollSubject.next(this.LastTarget);
        } else if (typeof (this.LastTarget) != 'undefined' && this.LastTarget.Id != '' && lastIndex == '') {
            this.LastTarget = new ScrollSubject(this.Guid, this.Selector, lastIndex, 0, null);
            this.ScrollSubject.next(this.LastTarget);
        }
    }
};

export class ScrollSubject {
    constructor(guid: string, selector: string, id: string, offset: number, target: HTMLElement) {
        this.Guid = guid;
        this.Selector = selector;
        this.Target = target;
        this.Id = id;
        this.Offset = offset;
    }

    Guid: string;
    Target: HTMLElement;
    Selector: string;
    Id: string;
    Offset: number;
}

//(function () {
//    'use strict';

//    var section = document.querySelectorAll(".section");
//    var sections = {};
//    var i = 0;

//    Array.prototype.forEach.call(section, function (e) {
//        sections[e.id] = e.offsetTop;
//    });

//    window.onscroll = function () {
//        var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

//        for (i in sections) {
//            if (sections[i] <= scrollPosition) {
//                document.querySelector('.active').setAttribute('class', ' ');
//                document.querySelector('a[href*=' + i + ']').setAttribute('class', 'active');
//            }
//        }
//    };
//})();